module.exports = __webpack_public_path__ + "static/media/eye.bc04528a.svg";